module.exports = __webpack_public_path__ + "static/media/java.54b08992.png";